import { render, staticRenderFns } from "./DashboardGlobalParameters.vue?vue&type=template&id=75c1e085&scoped=true&"
import script from "./DashboardGlobalParameters.vue?vue&type=script&lang=ts&"
export * from "./DashboardGlobalParameters.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardGlobalParameters.vue?vue&type=style&index=0&id=75c1e085&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c1e085",
  null
  
)

export default component.exports